export default __webpack_public_path__ + "static/media/recomposerapp.e92dfe77.png";